import { Controller } from 'stimulus';

import { showDateRangesPopover } from './date_ranges_popover_controller';

export default class extends Controller {
  showDateRangesPopover() { showDateRangesPopover(); }
}
